import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import SlickCss from 'slick-carousel/slick/slick.scss';
import SlickhemeCss from 'slick-carousel/slick/slick-theme.scss';
import SlickLightboxCss from 'slick-lightbox/dist/slick-lightbox.css';
import Slick from 'slick-carousel';
import SlickLightbox from './slick-lightbox.js';

import PsCss from 'perfect-scrollbar/css/perfect-scrollbar.css';
import Ps from 'perfect-scrollbar';

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"


class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    function globalNavMenu() {
      $(".l-global-nav__main li.has-child").hover(
        function () {
          $(".l-global-nav__layer").addClass("is-active");
          var left = $(this).offset().left - 17; // 17:矢印の半分を引く
          var width = $(this).width();
          left = left + (width / 2);
          $(this).find(".l-global-nav__sub__pointer").offset({left: left});
        },
        function () {
          $(".l-global-nav__layer").removeClass("is-active");
        }
      );
    }

    function toggleCategoryList() {
      $(".c-toggle-category").click(function () {
        $(this).toggleClass("is-closed");
        var target = $(this).attr("data-target");
        if ($(this).hasClass("is-closed")) {
          $(target + " .c-category-navi__level3").stop(true, false).slideUp();
        } else {
          $(target + " .c-category-navi__level3").stop(true, false).slideDown();
        }
      });
    }

    function scrollAdaptive() {

      $(window).on('scroll', function (event) {
        // ヘッダーの高さを取得
        var header_height = $(".l-header").height();
        // elScrollableは別項「スクロール位置の取得」を参照
        var scroll_top = $(window).scrollTop();
        if (scroll_top <= header_height) {
          var offset = header_height - scroll_top;
          $(".l-global-nav__layer").css({height: "calc(100% - " + offset + "px )"})
        } else {
          $(".l-global-nav__layer").css({height: "100%"})
        }

        // SP時スクロール後にヘッダー背景を白に変更する
        if (scroll_top >= 40) {
          $("body").addClass("is-scrolling");
        } else {
          $("body").removeClass("is-scrolling");
        }
      });
    }

    function searchDialog() {
      $(".js-open-search-dialog").click(function () {
        var target = $(this).attr("data-target");
        $(target).addClass("is-active");
      });
      $(".js-close-search-dialog").click(function () {
        $(this).parents(".l-dialog").removeClass("is-active");
        $(".l-dialog__layer").removeClass("is-active");
      });
    }

    var mainVisual = function () {
      if ($('.c-main-visual').length === 0) {
        return false;
      }
      var target01 = $('.c-main-visual__image .owl-carousel');
      var apsDuration = 1300;

      target01.imagesLoaded(function () {
        target01.owlCarousel({
          loop: true,
          nav: false,
          dots: true,
          lazyLoad: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: apsDuration,
          autoWidth: false,
          autoHeight: true,
          center: true,
          items: 1,
          margin: 0,
        });


        var $content = $('.c-main-visual__content');
        target01.on('changed.owl.carousel', function (event) {
          var item = event.item.index;
          var flagIndex = event.item.index;
          var $content = $('.c-main-visual__content');
          var $page = $('.c-main-visual__page');
          if ($content.length > 1) {
            $content.each(function () {
              $(this).removeClass('active');
            });
            $page.each(function () {
              $(this).removeClass('active');
            });
            $content.eq(flagIndex - 2).addClass('active');
            $page.eq(flagIndex - 2).addClass('active');
          }
        });
        if ($content.length > 1) {
          $('.c-main-visual__content:last-child').clone().appendTo($('.c-main-visual__text ul'));
        }
      });
    };

    function rpcnt() {
      var $wrap = $('.wpp-list');
      if ($wrap.length === 0) {
        return false;
      }
      console.log($wrap);
      $wrap.find('li').each(function (i) {
        var num = i + 1;
        var $_html = '<div class="c-sidebar__image-block__cnt">' + num + '位</div>';
        $(this).find('a').before($_html);
      });
    }

    $(function () {
      rpcnt()
      $('.c-case-slider .owl-carousel').owlCarousel({
        items: 4,
        margin: 16
      });
      // $('.c-main-visual').owlCarousel({
      //   items: 1,
      //   margin: 0,
      //   dots: true,
      //   loop: true,
      //   nav: true,
      //   autoplayHoverPause: true,
      //   autoplay: true,
      //   autoplaySpeed: 500,
      //   center: true,
      //   navText: ['<img src="/wp-content/themes/site-n-wp/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/site-n-wp/assets/images/icon-slider-next.svg" />'],
      // });
      //

      // buildFormat();
      mainVisual();
      globalNavMenu();
      toggleCategoryList();
      scrollAdaptive();
      searchDialog();
      $.fn.responsiveTable = (function () {
        var $window = $(window);
        return function () {
          var $el = this;
          var $table = this.find(' > table');
          var onResize = function () {
            var width = $table.outerWidth();
            var height = $table.outerHeight();
            var $parent = $el.parent();
            var containerWidth = $parent.width();
            var ratio = containerWidth / width;
            if (ratio < 1) {
              $el.height(height * ratio);
              $table.css('transform', 'scale(' + ratio + ')');
            } else {
              $el.height('');
              $table.css('transform', '');
            }
          };
          $table.css('transformOrigin', '0 0');
          $window.on('resize', onResize);
          onResize();
        };
      }());
      $('.l-post-content table').each(function () {
        var table = $(this);
        var $wrap = $('<div />', {
          class: "js-responsive-table"
        });
        table.after($wrap);
        $wrap.append(table);
        $wrap.responsiveTable();
      })
      // use
      $(".l-post-content table.is-responsive").responsiveTable();
      var $sliders = $('.js-image-slider');
      if ($sliders.length) {
        $sliders.each(function () {
          var $slider = $(this);
          $slider.on('init', function (event, slick) {
            $(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
            $('.current').text(slick.currentSlide + 1);
            $('.total').text(slick.slideCount);
          }).slick({
            infinite: true,
            arrows: true,
          }).slickLightbox({
            caption: function (el) {
              if ($(el).next(".c-slide-item__desc").length) {
                return $(el).next(".c-slide-item__desc").html()
              }
              return " ";
            }
          }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.current').text(nextSlide + 1);
          });
          if ($slider.find(".c-slide-item__desc").length) {
            new Ps($slider.find(".c-slide-item__desc")[0], {
              wheelSpeed: 2,
              wheelPropagation: true,
              minScrollbarLength: 20
            });
          }
        })

      }


    });
  }
}

window.GApp = new App();
